<template>
    <v-container fluid>
        <!-- <v-row align="center">
                <v-col class="d-flex" cols="10" sm="10">
                    <v-btn rounded="circle" size="small" class="back_btn mr-2" @click="back()" v-if="inAdmin()">
                        <v-icon>$navigate_before</v-icon>
                    </v-btn>
                    <h1 v-if="inAdmin()">{{company.name}}</h1>
                </v-col>
                <v-col cols="2" class="d-flex jsutify-end">
                    <v-btn
                        icon
                        color="primary"
                        @click="startTuto()"
                    >
                        <v-icon>$oss-help</v-icon>
                    </v-btn>
                </v-col> -->
        <!-- <v-col cols="2">
                    <v-btn
                        @click="() => this.wizard = true"
                    >
                        Wizard
                    </v-btn>
                </v-col> -->
        <!-- </v-row> -->
        <v-tabs
            grow
            v-model="activeTab"
            style="background: #f4f4f4; border-radius: 16px; overflow: hidden"
        >
            <v-tab ripple value="Company" href="#Company" data-cy="CompanyEdition-company">{{
                $t("settings.company")
            }}</v-tab>
            <v-tab
                ripple
                value="Users"
                href="#Users"
                v-if="companyId && mode !== 'auditReport' && enableUserRead"
                data-cy="CompanyEdition-users"
                >{{ $t("settings.users") }}</v-tab
            >
            <!-- <v-tab ripple value="Establishments" href="#Establishments" v-if="companyId && inAdmin()">{{ $t("settings.establishments") }}</v-tab> -->
            <v-tab
                ripple
                value="AccountingPeriods"
                id="AccountingPeriodsTabCompanyEdition"
                href="#AccountingPeriods"
                v-if="companyId && mode !== 'auditReport'"
                data-cy="CompanyEdition-accountingPeriods"
                >{{ $t("settings.exercices") }}</v-tab
            >
            <v-tab
                ripple
                value="Bank"
                href="#Bank"
                v-if="
                    currentUser.profile.configuration.bankAccount.read &&
                    companyId &&
                    mode !== 'auditReport'
                "
                data-cy="CompanyEdition-bank"
                >Banques</v-tab
            >
            <v-tab
                ripple
                value="Invoices"
                href="#Invoices"
                v-if="companyId && mode !== 'auditReport' && isAllowedToInvoice"
                data-cy="CompanyEdition-invoices"
                >Ma facturation</v-tab
            >
            <!-- <v-tab ripple value="Suggestions" href="#Suggestions" v-if="companyId && inAdmin()">Suggestions</v-tab> -->
            <v-tab
                ripple
                value="ConfigAPI"
                href="#ConfigAPI"
                v-if="companyId && (inAdmin() || mode !== 'auditReport')"
                data-cy="CompanyEdition-configAPI"
                >Configuration</v-tab
            >
            <v-tab
                ripple
                value="Connectors"
                href="#Connectors"
                v-if="companyId && mode !== 'auditReport'"
                data-cy="CompanyEdition-connectors"
                >Connecteurs</v-tab
            >
            <v-tab
                ripple
                value="BoniMali"
                href="#BoniMali"
                v-if="gainOrLossReadRight && mode !== 'auditReport'"
                data-cy="CompanyEdition-boniMali"
                >Boni Mali</v-tab
            >
        </v-tabs>
        <v-tabs-window v-model="activeTab" class="company-tabs-window">
            <!-- company description -->
            <v-tabs-window-item
                key="Company"
                value="Company"
                style="background: #f4f4f4; height: 100%"
                class="pt-2"
            >
                <EditCompany
                    :settingsMode="true"
                    :adminMode="inAdmin()"
                    :companyId="companyId"
                    :auditReportMode="mode === 'auditReport'"
                >
                </EditCompany>
            </v-tabs-window-item>
            <!-- Users -->
            <v-tabs-window-item
                v-if="companyId"
                key="Users"
                value="Users"
                style="background: #f4f4f4"
            >
                <UserTable
                    :companyId="companyId"
                    :mode="inAdmin() ? undefined : 'customer'"
                    :userTypeSelectable="false"
                />
            </v-tabs-window-item>
            <!-- Establishments -->
            <!-- <v-tab-item key="Establishments" value="Establishments" v-if="companyId && inAdmin()">
                    <Establishments
                        :company="company"
                    ></Establishments>
                </v-tabs-window-item> -->
            <!-- Client companies -->
            <!-- Accounting period  -->
            <v-tabs-window-item
                v-if="companyId && company.accountingPeriods"
                key="AccountingPeriods"
                value="AccountingPeriods"
                style="background: #f4f4f4"
            >
                <AccountingPeriods :companyId="companyId" :updateStore="true" />
            </v-tabs-window-item>
            <!-- Bank  -->
            <v-tabs-window-item
                v-if="companyId"
                key="Bank"
                value="Bank"
                style="background: #f4f4f4"
            >
                <BankConfig
                    v-bind:companyId="companyId"
                    :companyBudgetInsightId="company.budgetInsightId"
                />
            </v-tabs-window-item>
            <!-- Invoices -->

            <v-tabs-window-item key="Invoices" value="Invoices" style="background-color: #f4f4f4">
                <InvoiceThemeEdition :companyId="companyId" />
            </v-tabs-window-item>
            <v-tabs-window-item
                key="Connectors"
                value="Connectors"
                style="background-color: #f4f4f4"
            >
                <Connectors :companyId="companyId" />
            </v-tabs-window-item>
            <!-- <v-tabs-window-item ripple key="AccountingFirms" value="AccountingFirms" style="background-color: #F4F4F4">
                    <AccountingFirms
                        v-bind:accountingFirm="company"
                    ></AccountingFirms>
                </v-tabs-window-item> -->
            <v-tabs-window-item
                key="AccountingWorkspaces"
                value="AccountingWorkspaces"
                style="background-color: #f4f4f4"
            >
                <AccountingWorkspaces v-bind:accountingFirm="company" />
            </v-tabs-window-item>
            <v-tabs-window-item key="ConfigAPI" value="ConfigAPI" v-if="activeTab === 'ConfigAPI'">
                <v-row class="d-flex justify-center">
                    <!-- <v-col class="d-flex justify-start" cols="10" sm="8">
                            <h1>Configuration</h1>
                        </v-col> -->
                    <!-- <v-col cols="8" class="mt-3">
                            <v-row no-gutters class="d-flex justify-end">
                                <v-col cols="3">
                                    <v-btn

                                        block
                                        color="primary"
                                        height="40px"
                                        elevation="0"
                                        class="rounded-lg gradient"
                                        @click="validConfigApi()"
                                    >Modifier</v-btn>
                                </v-col>
                            </v-row>
                        </v-col> -->
                </v-row>
                <ConfigAPI
                    ref="configApi"
                    :companyId="companyId"
                    :inProfileId="
                        company && company.profile && company.profile.id ? company.profile.id : ''
                    "
                    :externalValidation="true"
                    :companyIncomeCategory="
                        company && company.incomeCategory ? company.incomeCategory : ''
                    "
                    :companyTaxSystemType="
                        company && company.taxSystemType ? company.taxSystemType : ''
                    "
                    :companyLegalForm="company && company.legalForm ? company.legalForm : ''"
                />
            </v-tabs-window-item>
            <v-tabs-window-item
                key="BoniMali"
                value="BoniMali"
                v-if="activeTab === 'BoniMali'"
                style="background: #f4f4f4"
            >
                <v-row>
                    <v-col class="d-flex justify-start" cols="12" sm="8">
                        <h1>Boni Mali</h1>
                    </v-col>
                </v-row>
                <BoniMali :companyId="companyId" />
            </v-tabs-window-item>
        </v-tabs-window>
        <!-- <v-dialog v-model="wizard">
                <WizardConfiguration
                    @close="() => this.wizard = false"
                ></WizardConfiguration>
            </v-dialog> -->
    </v-container>
</template>
<script lang="ts">
import axios from "axios";
import gql from "graphql-tag";
import { Component, Prop, Ref, Vue, toNative } from "vue-facing-decorator";
import { User } from "../../store/store";

import registrationTowns from "../../assets/json/registrationTowns.json";
import UPDATE_SUGESTION_STATUS from "../../graphql/admin/UpdateCompanySuggestion.gql";
// import DELETE_TAG from "../../graphql/DisconnectTag.gql";
// import CREATE_TAG from "../../graphql/company/UpdateCompanyTags.gql";
// import CREATE_ORPHAN_TAG from "../../graphql/company/UpdateCompanyTagsOrphan.gql";
// import UPDATE_CLIENT_COMPANIES from "../../graphql/company/ArchiveCompanyClientCompanies.gql";
// import ACCOUNTING_PERIOD_CREATE from "../../graphql/accountingPeriod/AccountingPeriodCreate.gql";
// import ACCOUNTING_PERIOD_UPDATE from "../../graphql/accountingPeriod/AccountingPeriodUpdate.gql";
import COMPANY_ACTIVITIES from "../../graphql/CompanyActivities.gql";
import GET_COMPANY_OFFER from "@/graphql/company/GetCompanyOffer.gql";

import AccountingPeriods from "../configuration/AccountingPeriods.vue";
import AccountingWorkspaces from "../configuration/AccountingWorkspaces.vue";
import BankConfig from "../configuration/Bank.vue";
import Connectors from "../configuration/connectors/Connectors.vue";
import Establishments from "../configuration/Establishments.vue";
import EditCompany from "../EditCompany.vue";
import InvoiceThemeEdition from "../invoiceTheme/InvoiceThemeEdition.vue";
import BoniMali from "./BoniMali.vue";
import CompanyTableComponent from "./CompaniesTable.vue";
import ConfigAPI from "./ConfigAPI.vue";
import Suggestions from "./Suggestions.vue";
import UserTable from "./UserTable.vue";
// import AccountingFirms from "../configuration/AccountingFirms.vue";
import { Apollo, State2Way } from "@/decorators";
import { CompanyVatSystem, getVATSystem } from "@/services/vat/vatHelpers.services";
import { FormSelectOption } from "@/types/formSelectOption.types";
import { Company, Tag } from "../../../../types";
import { OfferAccessRight } from "../../services/accessRightServices";
import { Offer_type } from "@/types/offer.types";

@Component({
    components: {
        companyTable: CompanyTableComponent,
        UserTable,
        Suggestions,
        AccountingPeriods,
        EditCompany,
        BankConfig,
        Establishments,
        ConfigAPI,
        Connectors,
        BoniMali,
        InvoiceThemeEdition,
        // AccountingFirms,
        AccountingWorkspaces,
    },
})
export class CompanyEdition extends Vue {
    @Prop({ default: "" }) mode: string;

    @Ref("configApi") configApi: any;

    loading = false;
    // skip = false;
    // activeSelectTag: boolean = false
    newTagPopUp: boolean = false;
    parent: any = null;
    nameTag: string = "";
    orphan: boolean = true;
    wizard: boolean = false;
    partitionId: string = "";
    newEstablishmentDialog: boolean = false;
    newEstablishmentEditDialog: boolean = false;
    companyEstablishmentEdit: any = null;
    enableAccountingFirms: boolean = false;
    isAccountingFirm: boolean = false;
    headers: Array<any> = [
        { text: "Partition Name", value: "", align: "left", sortable: false },
        { text: "Partition Name", value: "", align: "left", sortable: false },
        { text: "Tag Name", value: "", align: "left", sortable: false },
    ];

    get isAllowedToInvoice() {
        return OfferAccessRight.checkOfferAccessRight("isAllowedToInvoice", false, this.offerType);
    }

    get isGestOn() {
        return this.$store.state.user.profile.name.startsWith("geston");
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get gainOrLossReadRight() {
        return this.currentUser?.profile?.configuration?.gainOrLoss?.read;
    }

    // get gainOrLossWriteRight() {
    //     return this.currentUser?.profile?.configuration?.gainOrLoss?.write;
    // }

    @Apollo({
        query: COMPANY_ACTIVITIES,
        variables() {
            return {
                search: "",
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companyActivities) {
                    this.allActivities = data.companyActivities;
                }
            }
        },
    })
    allActivities: Array<any> = [];

    @Apollo(
        {
            query: gql`
                query invoiceSettings($companyId: ID!) {
                    company(where: { id: $companyId }) {
                        id
                        invoiceTextPaymentDetails
                        invoiceTextLegalNotices
                        invoiceTextPaymentMode
                        logo {
                            id
                            key
                            signedUrl
                        }
                    }
                }
            `,
            skip() {
                return !this.companyId;
            },
            variables() {
                return {
                    companyId: this.companyId,
                };
            },
        },
        (data) =>
            data
                ? data.company
                : {
                      invoiceTextPaymentDetails: "",
                      invoiceTextLegalNotices: "",
                      invoiceTextPaymentMode: "",
                  },
    )
    invoiceSettings = {
        invoiceTextPaymentDetails: "",
        invoiceTextLegalNotices: "",
        invoiceTextPaymentMode: "",
        logo: null,
    };

    activities = [];

    getActivityText(activity) {
        return activity.name; // + " (" + activity.description + ")";
    }

    legalForms: any = [
        { id: "ASSO", name: "Association" },
        { id: "CE", name: "Comité d'entreprise" },
        { id: "CL", name: "Collectivité locale" },
        { id: "CNE", name: "Commune" },
        { id: "COOP", name: "Coopérative" },
        { id: "CUMA", name: "Coopérative d'utilisation de matériel agricole" },
        { id: "DPT", name: "Département" },
        { id: "EARL", name: "Exploitation agricole à responsabilité limitée" },
        { id: "EC", name: "Entreprise collective" },
        { id: "EI", name: "Entreprise individuelle" },
        { id: "EIRL", name: "Entreprise individuelle à responsabilité limitée" },
        { id: "ETRANGER", name: "Personne morale de droit étranger" },
        { id: "EURL", name: "Entreprise unipersonnelle à responsabilité limitée" },
        { id: "FEDE", name: "Fédération" },
        { id: "FOND", name: "Fondation" },
        { id: "GAEC", name: "Groupement agricole d'exploitation en commun" },
        { id: "GEIE", name: "Groupement européen d'intérêt économique" },
        { id: "GF", name: "Groupement forestier" },
        { id: "GFA", name: "Groupement foncier agricole" },
        { id: "GFR", name: "Groupement foncier rural" },
        { id: "GIE", name: "Groupement d'intérêt économique" },
        { id: "GPT", name: "Groupement" },
        { id: "GREFFE", name: "Greffe" },
        { id: "IND", name: "Indivision" },
        { id: "MUT", name: "Mutuelle" },
        { id: "SA", name: "Société anonyme" },
        { id: "SAE", name: "Société anonyme d'exploitation" },
        { id: "SARL", name: "Société à responsabilité limitée" },
        { id: "SELARL", name: "Société d'exercice libéral à responsabilité limitée" },
        { id: "SAS", name: "Société anonyme par actions simplifiée" },
        {
            id: "SASU",
            name: "Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle",
        },
        { id: "SC", name: "Société civile (autre que infra)" },
        { id: "SCA", name: "Société en commandite par actions" },
        { id: "SCCV", name: "Société civile de construction vente" },
        { id: "SCE", name: "Société civile d'exploitation" },
        { id: "SCEA", name: "Société civile d'exploitation agricole" },
        { id: "SCEV", name: "Société civile d'exploitation vinicole" },
        { id: "SCH", name: "Société civile holding" },
        { id: "SCI", name: "Société civile immobilière" },
        { id: "SCM", name: "Société civile de moyens" },
        { id: "SCP", name: "Société civile professionnelle" },
        { id: "SCPG", name: "Société civile participation gestion" },
        { id: "SCPI", name: "Société civile de placement collectif immobilier" },
        { id: "SCS", name: "Société en commandite simple" },
        { id: "SCVV", name: "Société civile de vente volontaire" },
        { id: "SDE", name: "Société de droit étranger" },
        { id: "SNC", name: "Société en nom collectif" },
    ];
    // availableSalesAccounts = [
    //     { name: "701", description: "Ventes de produits finis" },
    //     { name: "702", description: "Ventes de produits intermédiaires" },
    //     { name: "704", description: "Travaux" },
    //     { name: "705", description: "Études" },
    //     { name: "706", description: "Prestations de services" },
    //     { name: "707", description: "Ventes de marchandises" },
    //     { name: "708", description: "Produits des activités annexes" },
    //     { name: "7081", description: "Produits des services exploités dans l'intérêt du personnel" },
    //     { name: "7082", description: "Commissions et courtages" },
    //     { name: "7083", description: "Locations diverses" },
    //     { name: "7084", description: "Mise à disposition de personnel facturée" },
    //     { name: "7085", description: "Frais de port et livraison" },
    //     { name: "7086", description: "Bonis sur reprises d'emballage consignés" },
    //     { name: "7087", description: "Bonifications obtenues des clients et primes sur ventes" },
    //     { name: "7088", description: "Autres produits d'activités annexes" },
    //     // { name: "709", description: "Rabais, remises et ristournes accordés par l'entreprise" }
    // ]

    // selectedCompanies = []
    companiesHeaders = [
        { text: "Selection", value: "" },
        { text: "Name", align: "left", sortable: false, value: "name" },
        { text: "Siret", value: "siret", sortable: false },
    ];

    accountingPeriodHeaders = [
        { text: "start", value: "start", align: "center", sortable: false },
        { text: "end", value: "end", align: "center", sortable: false },
    ];

    get disabled() {
        return !!this.companyId || !!this.$route.params.nameCompany;
    }

    get registrationTowns() {
        return registrationTowns;
    }

    vatSystems: Array<FormSelectOption> = [
        { id: CompanyVatSystem.NotSubjectTo, name: getVATSystem(CompanyVatSystem.NotSubjectTo) },
        {
            id: CompanyVatSystem.BelowTheThreshold,
            name: getVATSystem(CompanyVatSystem.BelowTheThreshold),
        },
        { id: CompanyVatSystem.Normal, name: getVATSystem(CompanyVatSystem.Normal) },
        { id: CompanyVatSystem.Quartely, name: getVATSystem(CompanyVatSystem.Quartely) },
        { id: CompanyVatSystem.Simplified, name: getVATSystem(CompanyVatSystem.Simplified) },
        {
            id: CompanyVatSystem.SimplifiedExercise,
            name: getVATSystem(CompanyVatSystem.SimplifiedExercise),
        },
        {
            id: CompanyVatSystem.FlatRateRefund,
            name: getVATSystem(CompanyVatSystem.FlatRateRefund),
        },
    ];

    taxSystems: any = [
        { id: "BIC_Normal", name: "BIC réel normal" }, // industrial and commercial profits
        { id: "BIC_Simplified", name: "BIC réel simplifié" }, // industrial and commercial profits
        { id: "BNC", name: "BNC" }, // bénéfice non commerciaux
        // { id: "SCI", name: "SCI" }, // OBSOLETE Société civile immobilière
        { id: "RF", name: "Revenus fonciers" },
    ];

    taxSystemTypes: any = [
        { id: "IS", name: "Impôt sur les Sociétés" },
        { id: "IR", name: "Impôt sur les Revenus" },
    ];

    refresh() {
        if (this.$apollo.queries) {
            if (this.$apollo.queries.company) {
                this.$apollo.queries.company.refetch();
            }
        }
    }

    get partitions() {
        if (this.company.tags) {
            const parents: Array<Tag> = [];
            this.company.tags.forEach((tag) => {
                if (tag.partitionTag !== null) {
                    parents.push(tag);
                }
            });
            const partitions: Array<any> = parents.map((x) => ({
                name: x.partitionTag.name,
                id: x.partitionTag.id,
            }));
            const removeDuplicates = (list) =>
                list.reduce((r, i) => (!r.some((j) => i.id === j.id) ? [...r, i] : r), []);
            return removeDuplicates(partitions);
        }
        return [];
    }

    get tags() {
        let result = [];
        const parents = [];
        const orphans = [];
        if (this.company.tags) {
            this.company.tags.forEach((tag) => {
                if (tag.partitionTag !== null) {
                    parents.push(tag);
                } else if (tag.partitionTag === null) {
                    orphans.push(tag);
                } else {
                    // debugger;
                }
            });
        }
        const partitions = parents.map((x) => x.partitionTag);
        const removeDuplicates = (list) =>
            list.reduce((r, i) => (!r.some((j) => i.id === j.id) ? [...r, i] : r), []);
        result = removeDuplicates(JSON.parse(JSON.stringify(partitions)));
        parents.forEach((tag) => {
            const partition = result.find((x) => x.id === tag.partitionTag.id);
            if (partition.tags) {
                partition.tags.push({
                    name: tag.name,
                    id: tag.id,
                });
            } else if (partition) {
                partition.tags = [
                    {
                        name: tag.name,
                        id: tag.id,
                    },
                ];
            } else {
                // debugger;
            }
        });
        orphans.forEach((tag) => {
            result.push({
                name: "",
                id: "",
                tags: [{ id: tag.id, name: tag.name }],
            });
        });
        return result;
    }

    get companyId() {
        if (this.$route.params.id) {
            return this.$route.params.id;
        } else if (this.$route.params.companyId) {
            return this.$route.params.companyId;
        }
        return undefined;
    }

    /**
     * Suprimée parce que il y a un erreur. Tag n'est pas 1 partie du company mais tags.
     *
      get tag() {
        const company = this.company;
        if (company && company.tag) {
            return company.tag;
        }
        return {
            name: "Définir une catégorie",
            id: "",
        };
    }
     */

    @State2Way("upsertCompanyEditionActiveTab", "companyEdition.activeTab")
    activeTab: string;

    beforeMount() {
        if (this.mode === "auditReport") {
            this.activeTab = "Company";
        } else if (this.$route.params.activeTab)
            this.activeTab = this.$route.params.activeTab as string;
        this.company = JSON.parse(JSON.stringify(this.defaultCompany));
        if (this.$route.params.nameCompany) {
            this.company.name = this.$route.params.nameCompany as string;
        }
        if (this.$route.params.siret) {
            this.company.siret = this.$route.params.siret as string;
        }
        if (this.$route.params.siren) {
            this.company.siren = this.$route.params.siren as string;
        }
        if (this.$route.params.vatNumber) {
            this.company.vatNumber = this.$route.params.vatNumber as string;
        }
        if (this.$route.params.address) {
            this.company.address = this.$route.params.address as string;
        }
        if (this.$route.params.postalCode) {
            this.company.postalCode = this.$route.params.postalCode as string;
        }
        if (this.$route.params.country) {
            this.company.country = this.$route.params.country as string;
        }
        if (this.$route.params.city) {
            this.company.city = this.$route.params.city as string;
        }
        if (this.$route.params.activities) {
            // this.allActivities = (this.$route.params.activities as any).map((activity) => {
            //     return { text: activity, value: activity };
            // });
            this.activities = this.$route.params.activities as any;
        }
        // if (this.$route.params.legalFormTitle) {
        //     this.company.legalFormTitle = this.$route.params.legalFormTitle
        // }
    }

    back() {
        this.$router.go(-1);
    }

    @Apollo({
        query: gql`
            query companyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    shortName
                    siret
                    siren
                    vatNumber
                    legalForm
                    legalFormCategory
                    isActive
                    vatSystem
                    taxSystem
                    taxSystemType
                    withManager
                    vehicle
                    shop
                    budgetInsightId
                    salaryCount
                    shareCapital
                    registrationTown
                    profile {
                        id
                    }
                    # establishments {
                    #     id
                    #     name
                    #     address
                    #     city
                    #     country
                    #     postalCode
                    #     siren
                    #     siret
                    # }
                    users {
                        id
                        email
                    }
                    activities {
                        id
                        name
                        description
                    }
                    suggestions {
                        id
                        status
                        purchaseAccount {
                            id
                            type
                            name
                            description
                        }
                        salesAccount {
                            id
                            type
                            name
                            description
                        }
                        count
                    }
                    address
                    postalCode
                    city
                    country
                    clientCompanies {
                        id
                        name
                        siret
                    }
                    enableAccountingFirms
                    accountingFirm
                    accountingPeriods {
                        id
                        start
                        end
                        closed
                        isAccountingSituationOf {
                            id
                            start
                            end
                        }
                    }
                    salesAccounts {
                        id
                        name
                        description
                    }
                    accountingFirms {
                        id
                        name
                        siret
                    }
                    isAccountingFirmOf {
                        id
                        name
                        siret
                    }
                    incomeCategory
                    taxRegime
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.company) {
                    const company = data.company;
                    if (company.clientCompanies) {
                        for (const cc of company.clientCompanies) {
                            cc.selected = true;
                        }
                    } else {
                        company.clientCompanies = [];
                    }
                    this.company = company;
                    this.enableAccountingFirms = company.enableAccountingFirms;
                    this.isAccountingFirm = company.accountingFirm;
                    // if (this.company.clientCompanies) {
                    //     // this.selectedCompanies = this.company.clientCompanies.map(c => c.id);
                    //     this.selectedCompanies = this.company.clientCompanies.map(cc => cc);
                    // } else {
                    //     this.selectedCompanies.splice(0, this.selectedCompanies.length);
                    // }
                    // this.allActivities = this.company.activities.map((activity) => { return { text: activity.name, value: activity.name } })
                    this.activities = this.company.activities.map((activity) => activity.name);
                    // let mStartDate = moment().startOf("day");
                    if (this.company.accountingPeriods && this.company.accountingPeriods.length) {
                        this.company.accountingPeriods.sort((a, b) => {
                            return a.start > b.start ? -1 : 1;
                        });
                        //     const accountingPeriod = this.company.accountingPeriods[this.company.accountingPeriods.length - 1];
                        //     mStartDate = moment(accountingPeriod.end);
                    }
                    // this.updateNewPeriodDates(mStartDate);
                }
            }
        },
    })
    company: Company = {
        name: "",
        shortName: "",
        siret: "",
        siren: "",
        vatNumber: "",
        legalForm: "SAS",
        legalFormCategory: undefined,
        isActive: true,
        vatSystem: "Normal",
        taxSystem: "BIC_Normal",
        taxSystemType: "IS",
        withManager: true,
        vehicle: false,
        shop: false,
        salaryCount: 0,
        shareCapital: 0,
        registrationTown: "",
        activities: [],
        address: "",
        budgetInsightId: null,
        postalCode: "",
        city: "",
        country: "",
        accountingPeriods: [],
        tags: [],
        clientCompanies: [],
        salesAccounts: [],
        incomeCategory: "BIC",
        taxRegime: "REAL_NORMAL",
        // establishments: []
    };

    defaultCompany: Company = {
        name: "",
        shortName: "",
        siret: "",
        siren: "",
        vatNumber: "",
        legalForm: "SAS",
        legalFormCategory: undefined,
        isActive: undefined,
        vatSystem: "Normal",
        taxSystem: "BIC_Normal",
        taxSystemType: "IS",
        withManager: true,
        vehicle: false,
        shop: false,
        budgetInsightId: null,
        salaryCount: 0,
        shareCapital: 0,
        registrationTown: "",
        activities: [],
        address: "",
        postalCode: "",
        city: "",
        country: "",
        // accountingPeriods: [],
        // tags: [],
        clientCompanies: [],
        salesAccounts: [],
        incomeCategory: "BIC",
        taxRegime: "REAL_NORMAL",
        // establishments: []
    };

    updateCompany: boolean = false;
    // async getSelectTag(data){
    //     this.activeSelectTag = false
    //     //@ts-ignore
    //     this.company.tag = data
    // }

    showTagCreator(itemId: string) {
        this.partitionId = itemId;
        this.newTagPopUp = true;
    }

    showTagOrphanCreator() {
        this.partitionId = "";
        this.newTagPopUp = true;
    }
    // async tagCreation() {
    //     if (!this.orphan) {
    //         await this.$apollo.mutate({
    //             mutation: CREATE_TAG,
    //             variables: {
    //                 tagName: this.nameTag,
    //                 partitionTag: this.partitionId,
    //                 companyId: this.companyId
    //             }
    //         });
    //     } else {
    //         await this.$apollo.mutate({
    //             mutation: CREATE_ORPHAN_TAG,
    //             variables: {
    //                 tagName: this.nameTag,
    //                 companyId: this.companyId
    //             }
    //         });
    //     }
    //     this.newTagPopUp = false;
    // }
    // async deleteTag(id: string) {
    //     console.log(id);
    //     console.log(this.companyId);
    //     await this.$apollo.mutate({
    //         mutation: DELETE_TAG,
    //         variables: {
    //             companyId: this.companyId,
    //             tagID: id
    //         }
    //     });
    //     const index = this.company.tags.findIndex(x => x.id === id);
    //     this.company.tags.splice(index, 1);
    // }

    async onChangeStatus(data) {
        await this.$apollo.mutate({
            mutation: UPDATE_SUGESTION_STATUS,
            variables: data,
        });
    }

    dialogSelectCompany: boolean = false;

    // async companySelected(obj: Company) {
    //     // console.log(obj);
    //     if (obj.id) {
    //         const existingCompany = this.company.clientCompanies.find(cc => cc.id === obj.id);
    //         if (existingCompany) {
    //             if (!(existingCompany as any).selected) {
    //                 (existingCompany as any).selected = true;
    //                 await this.addRemoveItem(existingCompany);
    //             }
    //         } else {
    //             (obj as any).selected = true;
    //             this.company.clientCompanies.push(obj);
    //             await this.addRemoveItem(obj);
    //         }
    //     }
    //     this.dialogSelectCompany = false;
    // }

    setLogoInput() {
        console.log(this.$refs.logo);
        document.getElementById("companyLogo").click();
    }

    // async addRemoveItem(obj) {
    //     if (this.companyId) {
    //         const disconnectClientCompanies = [];
    //         const connectClientCompanies = [];
    //         if (obj.selected) {
    //             connectClientCompanies.push(obj.id);
    //         } else {
    //             disconnectClientCompanies.push(obj.id);
    //         }
    //         const result = await this.$apollo.mutate({
    //             mutation: UPDATE_CLIENT_COMPANIES,
    //             variables: {
    //                 id: this.companyId,
    //                 disconnectClientCompanies: disconnectClientCompanies,
    //                 connectClientCompanies: connectClientCompanies,
    //             },
    //         });
    //     }
    // }
    //
    // accounting period
    //

    inAdmin() {
        return this.$route.fullPath.startsWith("/admin");
    }

    //
    // Invoice
    //
    async fileLogoChange(file) {
        console.log("change", file);
        if (file) {
            console.log("type", file.type);
            const res: any = await this.$apollo.query({
                query: gql`
                    query fileUploadSignedURL(
                        $name: String!
                        $sha256: String
                        $contentType: String!
                        $companyId: ID!
                    ) {
                        fileUploadSignedURL(
                            data: {
                                name: $name
                                sha256: $sha256
                                contentType: $contentType
                                companyId: $companyId
                            }
                        ) {
                            status
                            url
                            key
                        }
                    }
                `,
                fetchPolicy: "network-only",
                variables: {
                    name: file.name,
                    sha256: undefined,
                    contentType: file.type,
                    companyId: this.companyId,
                },
            });
            let type = "";
            if (file.type === "image/png") type = "PNG";
            else if (file.type === "image/jpg") type = "JPG";
            else if (file.type === "image/jpeg") type = "JPEG";
            else if (file.type === "image/tiff") type = "TIFF";
            else if (file.type === "image/tif") type = "TIF";
            axios
                .put(res.data.fileUploadSignedURL.url, file, {
                    headers: {
                        "Content-Type": file.type,
                    },
                })
                .then(async () => {
                    const result = await this.$apollo.mutate({
                        mutation: gql`
                            mutation addLogo($companyId: ID!, $key: String!, $type: FileExt!) {
                                updateCompany(
                                    where: { id: $companyId }
                                    data: { logo: { create: { key: $key, type: $type } } }
                                ) {
                                    id
                                    logo {
                                        id
                                        key
                                        signedUrl
                                    }
                                }
                            }
                        `,
                        variables: {
                            companyId: this.companyId,
                            key: res.data.fileUploadSignedURL.key,
                            type: type,
                        },
                    });
                    this.invoiceSettings.logo.signedUrl = result.data.updateCompany.logo.signedUrl;
                })
                .catch(() => {
                    console.log("FAILURE!!");
                });
        }
    }

    validConfigApi() {
        this.configApi.updateProfile();
    }

    enableUserRead() {
        return this.currentUser.profile.configuration.user.read;
    }

    getOfferStringValue(offer) {
        switch (offer) {
            case "ACCOUNTING_STARTER":
                return Offer_type.ACCOUNTING_STARTER;
            case "ACCOUNTING_BASIC":
                return Offer_type.ACCOUNTING_BASIC;
            case "ACCOUNTING_ESSENTIAL":
                return Offer_type.ACCOUNTING_ESSENTIAL;
            case "ACCOUNTING_PREMIUM":
                return Offer_type.ACCOUNTING_PREMIUM;
            case "TRAINING":
                return Offer_type.TRAINING;
            case "BUSINESS_BASIC":
                return Offer_type.BUSINESS_BASIC;
            case "BUSINESS_SMART":
                return Offer_type.BUSINESS_SMART;
            case "BUSINESS_ESSENTIAL":
                return Offer_type.BUSINESS_ESSENTIAL;
            case "BUSINESS_PREMIUM":
                return Offer_type.BUSINESS_PREMIUM;
        }
    }

    @Apollo({

        query: GET_COMPANY_OFFER,
        fetchPolicy: "network-only",
        variables() {
            console.log("companyId", this.companyId);
            return {
                client: { id: this.companyId },
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.accountingFirmClients?.length) {
                    let lastDate: Date = null;
                    for (const accountingFirmClient of data.accountingFirmClients) {
                        if (
                            lastDate == null ||
                            lastDate.getTime() < new Date(accountingFirmClient.updatedAt).getTime()
                        ) {
                            this.offerType = this.getOfferStringValue(
                                accountingFirmClient.offer,
                            );
                            lastDate = new Date(accountingFirmClient.updatedAt);
                        }
                    }
                }
            }
        },
    })
    offerType: Offer_type;
}

export default toNative(CompanyEdition);
</script>
<style lang="scss">
hr {
    border: none;
    border-top: 1px dashed #333;
}
.company-tabs-window {
    background-color: transparent !important;
    height: calc(100vh - 148px) !important;
    overflow-y: auto;
}
</style>
